import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import TabNavigation from "../../components/TabNavigation/TabNavigation";

const navigationItems = [
  { to: "/gyms-and-group-classes/open-gyms", text: "OpenGym" },
  { to: "/gyms-and-group-classes/group-classes", text: "GroupClasses" },
];

const GymsAndGroupClasses = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/gyms-and-group-classes") {
      navigate("/gyms-and-group-classes/open-gyms");
    }
  }, [location]);

  return (
    <div>
      <TabNavigation items={navigationItems} />
      <div className={"page-content"}>
        <Outlet />
      </div>
    </div>
  );
};

export default GymsAndGroupClasses;
